import React, { useEffect, useState, useRef } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import * as styles from "./MobileImageSlider.module.scss";

const SLIDE_DURATION = 5000;

const MobileImageSlider = ({ data }) => {
    const { slider } = data;
    const [currentIndex, setCurrentIndex] = useState(0);
    const [progress, setProgress] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        setProgress(0);
        const startTime = Date.now();

        intervalRef.current = setInterval(() => {
            const elapsed = Date.now() - startTime;
            const percent = Math.min((elapsed / SLIDE_DURATION) * 100, 100);
            setProgress(percent);

            if (percent >= 100) {
                clearInterval(intervalRef.current!);
                setCurrentIndex((prev) => (prev + 1) % slider.length);
            }
        }, 50);

        return () => clearInterval(intervalRef.current!);
    }, [currentIndex, slider.length]);

    const currentSlide = slider[currentIndex];

    return (
        <div className={styles.sliderContainer}>
            <div className={styles.mainWrapper}>
                <div className={styles.imageWrapper}  style={{ backgroundColor: currentSlide.backgroundColor }}>
                    <GatsbyImage
                        image={getImage(currentSlide.image2.gatsbyImageData)}
                        alt={currentSlide.image2.title}
                        className={styles.image2}
                    />
                </div>

                <div>
                    <div className={styles.imageWrapper2}>
                        <GatsbyImage
                            image={getImage(currentSlide.image5.gatsbyImageData)}
                            alt={currentSlide.image5.title}
                            className={styles.image}
                        />
                        <GatsbyImage
                            image={getImage(currentSlide.image6.gatsbyImageData)}
                            alt={currentSlide.image6.title}
                            className={styles.image3}
                        />
                        <GatsbyImage
                            image={getImage(currentSlide.image7.gatsbyImageData)}
                            alt={currentSlide.image7.title}
                            className={styles.image4}
                        />
                    </div>
                    <div className={styles.textWrapper}>
                        <div className={styles.content}>{currentSlide.mobileContent}</div>
                    </div>
                </div>



            </div>


            <div className={styles.progressBar}>
                <div
                    className={styles.progressFill}
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
};

export default MobileImageSlider;
